import { render, staticRenderFns } from "./NewsDetail1.vue?vue&type=template&id=494af2fe&scoped=true&"
import script from "./NewsDetail1.vue?vue&type=script&lang=js&"
export * from "./NewsDetail1.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetail1.vue?vue&type=style&index=0&id=494af2fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494af2fe",
  null
  
)

export default component.exports